import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { downloadInvoice, showAddCommentModal } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,

      isDownloading: localState.status === "Downloading",
      isEditMode: state.isEditMode,
      noImageUrl: getNoImageUrl(),
      orderSummary: localState.orderSummary,
      history: localState.history
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onDownload: () => dispatch(downloadInvoice(getEntityRef(props))),
  onClickAddComment: () => dispatch(showAddCommentModal(getEntityRef(props)))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
